import { Button } from "../components/ui/button";

const SecondarySection = () => {
  const handleScrollToPricing = () => {
    const element = document.getElementById("pricing-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-background_km to-muted_km">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Left - Placeholder for video/image */}
          <div className="bg-gradient-to-br from-muted_km to-accent_km/10 rounded-2xl aspect-video flex items-center justify-center order-2 lg:order-1">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/EqE95vGN08s"
              title="Astrology Video Content"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          {/* Right Content */}
          <div className="space-y-4 md:space-y-6 text-center lg:text-left order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground_km leading-tight">
              Your Marriage Deserves the Right Start

            </h2>

            <p className="text-lg md:text-xl text-muted_km-foreground leading-relaxed">
              <span className="italic">Discover strengths, challenges and remedies for a happy marriage</span>
            </p>

            <Button
              variant="astrology"
              size="xl"
              className="w-full sm:w-auto"
              onClick={handleScrollToPricing}
            >
              BUY YOUR KUNDALI MATCHING REPORT
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecondarySection;